import { useCallback } from 'react'

export const useAfterTransform = () => {
  const afterTransform = useCallback(
    (field, { rowIndex }) => ({
      ...field,
      rowIndex,
    }),
    []
  )

  return afterTransform
}
